import styled from "styled-components";

export const ListPanel = styled.div`
  background: #fff;
  border-radius: 20px;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 10px 32px rgba(23, 23, 23, 0.06);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const ListTitle = styled.h2`
  margin: 0;
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 800;
  color: #171717;
`;

export const CountBadge = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(23, 23, 23, 0.05);
`;

export const TableWrap = styled.div`
  overflow-x: auto;
  border-radius: 14px;
  border: 1px solid rgba(23, 23, 23, 0.06);
`;

/** Scroll container for tables inside full-height dashboard panels */
export const PanelTableScroll = styled.div<{ $hasActiveMenu?: boolean }>`
  width: calc(100% - 44px);
  margin: 0 22px;
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  min-height: 0;
  padding-bottom: ${({ $hasActiveMenu }) => ($hasActiveMenu ? "280px" : "0")};
`;

export const PaymentsTable = styled.table<{ $minWidth?: number }>`
  width: 100%;
  min-width: ${(p) => p.$minWidth ?? 620}px;
  border-collapse: collapse;

  th {
    padding: 12px 14px;
    text-align: left;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    background: #fafafa;
    border-bottom: 1px solid rgba(23, 23, 23, 0.06);
  }

  th span {
    background: linear-gradient(144.01deg, #ffc951 0%, #c94daa 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  td {
    padding: 12px 14px;
    font-family: Montserrat, sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: rgba(23, 23, 23, 0.82);
    border-bottom: 1px solid rgba(23, 23, 23, 0.05);
  }

  tbody tr:hover {
    background: rgba(201, 77, 170, 0.03);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const AmountCell = styled.span`
  font-weight: 700;
  color: #171717;
`;

export const RemainingCell = styled.span`
  font-weight: 700;
  color: #e44862;
`;

export const StatusPill = styled.span<{ $status: string }>`
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  background: ${(p) => {
    const s = p.$status.toLowerCase();
    if (s === "captured" || s === "completed" || s === "paid" || s === "active") return "rgba(49,166,106,0.12)";
    if (s === "pending" || s === "created") return "rgba(240,154,62,0.15)";
    if (s === "booked") return "rgba(99,102,241,0.12)";
    if (s === "inactive") return "rgba(23, 23, 23, 0.08)";
    return "rgba(228,72,98,0.12)";
  }};
  color: ${(p) => {
    const s = p.$status.toLowerCase();
    if (s === "captured" || s === "completed" || s === "paid" || s === "active") return "#31a66a";
    if (s === "pending" || s === "created") return "#f09a3e";
    if (s === "booked") return "#6366f1";
    if (s === "inactive") return "rgba(23, 23, 23, 0.6)";
    return "#e44862";
  }};
`;

export const ClickableStatusPill = styled.button<{ $status: string }>`
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  cursor: pointer;
  border: none;
  font-family: Montserrat, sans-serif;
  background: ${(p) => {
    const s = p.$status.toLowerCase();
    if (s === "active") return "rgba(49,166,106,0.12)";
    return "rgba(23, 23, 23, 0.08)";
  }};
  color: ${(p) => {
    const s = p.$status.toLowerCase();
    if (s === "active") return "#31a66a";
    return "rgba(23, 23, 23, 0.6)";
  }};

  &:hover {
    opacity: 0.85;
  }
`;

export const MethodPill = styled.span`
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  background: rgba(201, 77, 170, 0.1);
  color: #c94daa;
`;
